import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, Alert, Badge } from "reactstrap"
import { get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "common/loader";
import { ROLES } from "helpers/api_endpoints";
//meta title
document.title = "Roles List";
const RolesList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        get(ROLES)
            .then(response => {
                const data = response.data;
                setRoles(data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/logout');
                }
            })
    }, []);


    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg('');
            }, 4000)
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Roles" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <Link to="/roles/add" >
                                    <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                </Link>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>Id</Trans></th>
                                                    <th><Trans>Role Name</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    roles.map((role, index) => (
                                                        <tr key={index}>
                                                            <td>{role.id}</td>
                                                            <td>{role.name}</td>
                                                            <td><Link to={{ pathname: `/roles/edit/${role.id}` }} state={role}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={{ pathname: `/roles/remove/${role.id}` }} ><button className="btn btn-sm btn-danger"><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans></button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default RolesList
